/** Regras da busca na Base de Conhecimento que não dependem de tela (spec 2026-10-20-kb-busca). */
import type { KbFolderNode } from '@/api/kb'
import { dobrar } from '@/lib/dobrarAcento'
import { caminhoDe } from './arvore'

/** Pastas se filtram na própria árvore a partir de 2 caracteres. */
export const MINIMO_PASTAS = 2
/** O servidor só é chamado a partir de 3 (abaixo disso ele responde 422). */
export const MINIMO_SERVIDOR = 3
/** Espera depois da última tecla antes de chamar o servidor. */
export const ATRASO_MS = 500

export function termosDaBusca(q: string): string[] {
  return dobrar(q).split(/[^\p{L}\p{N}]+/u).filter((t) => t.length > 0)
}

/** Pastas cujo nome contém TODOS os termos, sem acento; o caminho vai junto para a pessoa saber onde ela está. */
export function pastasQueCasam(nos: KbFolderNode[], q: string): { no: KbFolderNode; caminho: string }[] {
  if (q.trim().length < MINIMO_PASTAS) return []
  const ts = termosDaBusca(q)
  if (ts.length === 0) return []
  return nos
    .filter((no) => ts.every((t) => dobrar(no.nome).includes(t)))
    .map((no) => ({ no, caminho: caminhoDe(nos, no.id) }))
}
